import type { VerifyPayJunctionResponse } from "@/openapi/generated/models";

export const convertTwoDigitYearToFour = (twoDigitYear: string): string => {
  const currentYear = new Date().getFullYear();
  const currentYearLastTwo = currentYear % 100;
  const currentCentury = Math.floor(currentYear / 100) * 100;
  const year = parseInt(twoDigitYear, 10);
  
  if (currentYearLastTwo >= 90 && year <= 9) {
    return String((currentCentury + 100) + year);
  }
  
  return String(currentCentury + year);
};

export const cleanCardNumber = (cardNumber: string): string => {
  return cardNumber.replace(/\s/g, '');
};

const VERIFY_PAYMENT_FALLBACK_MESSAGE =
  "Payment verification did not return a transaction ID";

export class VerifyPayJunctionError extends Error {
  constructor(
    response: VerifyPayJunctionResponse,
    fallbackMessage: string = VERIFY_PAYMENT_FALLBACK_MESSAGE,
  ) {
    super(getVerifyPayJunctionFailureMessage(response, fallbackMessage));
    this.name = "VerifyPayJunctionError";
  }
}

export function isVerifyPayJunctionError(
  error: unknown,
): error is VerifyPayJunctionError {
  return error instanceof VerifyPayJunctionError;
}

export function getVerifyPayJunctionFailureMessage(
  response: VerifyPayJunctionResponse,
  fallbackMessage: string = VERIFY_PAYMENT_FALLBACK_MESSAGE,
): string {
  return response.message?.trim() || fallbackMessage;
}

export function resolveVerifyPayJunctionTransactionId(
  response: VerifyPayJunctionResponse,
): string {
  const transactionId = response.transactionId?.trim();
  if (transactionId) return transactionId;

  throw new VerifyPayJunctionError(response);
}
